import { render, staticRenderFns } from "./ModalStatusSuccess.vue?vue&type=template&id=10bd72f2&scoped=true"
import script from "./ModalStatusSuccess.vue?vue&type=script&lang=js"
export * from "./ModalStatusSuccess.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10bd72f2",
  null
  
)

export default component.exports